// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TableCellMotif_motif__2NqWH {\n  margin-top: -3px;\n  margin-left: 5px;\n  position: absolute;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Includes/Table/TableCellMotif.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":[".motif {\n  margin-top: -3px;\n  margin-left: 5px;\n  position: absolute;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"motif": "TableCellMotif_motif__2NqWH"
};
export default ___CSS_LOADER_EXPORT___;
